import PasswordResetSuccess from './PasswordResetSuccess';

export default PasswordResetSuccess;
